<template>
  <div class="article-preview">
    <div id="drag-protect" class="drag-protect"></div>
    <iframe v-if="frameSrc" name="Opoint_attr" :src="frameSrc" frameborder="0" ref="frame"></iframe>
  </div>
</template>

<script>
  import { Events } from '../events.js'

  export default {
    name: 'ArticlePreview',
    data: () => ({
      frameSrc: null
    }),
    props: {
      urlDev: {
        type: String
      },
      article: Object
    },
    created() {
      Events.$on('reclassified', () => {
        this.frameSrc = `/api/classified/${this.article.id_link}?highlight=true&t=` + Number(new Date())
      })
    },
    watch: {
      article: {
        immediate: true,
        handler(val) {
          if (val) {
            this.frameSrc = `/api/classified/${val.id_link}?highlight=true&t=` + Number(new Date())
          }
        }
      }
    }
  }
</script>

<style lang="sass">
  @use '../styles/variables' as v

  .article-preview
    z-index: 0
    grid-area: article
    position: relative
    background-color: v.$white

    .drag-protect
      position: absolute
      left: 0
      top: 0
      width: 100%
      height: 100%
      z-index: 10
      display: none

    iframe
      z-index: 0

  iframe
    width: 100%
    height: 100%
</style>
